import Block, { TextBlockTypes } from './TextBlock';
function hasEmptyLineFormat(line) {
    return line === '' || line === ' ';
}
export function parseImage(line) {
    var _a;
    const match = line.match(/^!(.+)!#(.*)?#$/);
    if (!match) {
        return null;
    }
    return {
        path: match[1],
        caption: (_a = match[2]) !== null && _a !== void 0 ? _a : '',
    };
}
export default function getBlockType(line, typeBefore, nextLine) {
    line = line.replace('\u00A0', ' '); // replace non breaking space with a regular one
    if (hasEmptyLineFormat(line)) {
        return TextBlockTypes.Empty;
    }
    if (line.startsWith('# ')) {
        return TextBlockTypes.Header1;
    }
    if (line.startsWith('## ')) {
        return TextBlockTypes.Header2;
    }
    if (line.startsWith('### ')) {
        return TextBlockTypes.Header3;
    }
    if (line.startsWith('#### ')) {
        return TextBlockTypes.Header4;
    }
    if (line.startsWith('##### ')) {
        return TextBlockTypes.Header5;
    }
    if (line.startsWith('###### ')) {
        return TextBlockTypes.Header6;
    }
    if (line.startsWith('* ')) {
        return TextBlockTypes.BulletPointLevel1;
    }
    if (line.startsWith('>* ')) {
        return TextBlockTypes.DoneBulletPointLevel1;
    }
    if (line.startsWith('** ')) {
        return TextBlockTypes.BulletPointLevel2;
    }
    if (line.startsWith('>** ')) {
        return TextBlockTypes.DoneBulletPointLevel2;
    }
    if (line.startsWith('*** ')) {
        return TextBlockTypes.BulletPointLevel3;
    }
    if (line.startsWith('>*** ')) {
        return TextBlockTypes.DoneBulletPointLevel3;
    }
    else if (line.startsWith('!')) {
        const image = parseImage(line);
        if (image) {
            return TextBlockTypes.Image;
        }
    }
    return TextBlockTypes.Text;
}
export function getTextBlocks(fountain, idManager) {
    const blocks = [];
    const lines = fountain.split(/\r?\n/);
    let lastBlockType = undefined;
    lines.forEach((line, index) => {
        const blockType = getBlockType(line, lastBlockType, lines[index + 1]);
        blocks.push(new Block(idManager.getNextId(), blockType, line));
        lastBlockType = blockType;
    });
    return blocks;
}
